import React, {Component} from 'react';
import {Card, Col, notification, Row, Table, Tag} from 'antd';
import './financialSealHome.css';
import LoadingIndicator from "../../../common/LoadingIndicator";
import {fetchRequest, statistics} from "../../../util/APIUtils";
import ServerError from "../../../common/ServerError";
import NotFound from "../../../common/NotFound";
import AccessError from "../../../common/AccessError";
import Text from "antd/lib/typography/Text";
import moment from "moment";

class FinancialSealHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statistics: [],
            loading:false,
            content: [],
            total: 0,
            current: 1,
            pageSize: 5
        };
        this.fetchData = this.fetchData.bind(this);
        this.onChange  = this.onChange.bind(this);
    }

    componentDidMount() {
        this.setState({loading:true});
        statistics().then(response => {
            this.setState({
                statistics: response.data.statistics,
                loading:false
            },()=>{this.fetchData();});
        }).catch(error => {
            this.showError(error);
            this.setState({loading:false});
        });
    }

    fetchData() {
        let self = this;
        this.setState({loadingTable: true});
        const {current, pageSize} = self.state;
        fetchRequest({}, `/token/fetchAllApps?page=${current - 1}&size=${pageSize}&odemeDurumu=ODENDI&teslimatDurumu=TESLIM_EDILMEDI&sort=updatedAt,desc&sort=sender,desc`)
            .then(response => {
                let {number, size, totalElements, content} = response.data;
                this.setState({
                    loadingTable: false,
                    current: number + 1,
                    pageSize: size,
                    total: totalElements,
                    content
                });
            }).catch(error => {
            if (error.status === 404) {
                this.setState({notFound: true});
            } else if (error.response.status === 401) {
                notification.error({
                    message: 'Hata',
                    description: 'Kullanıcı adı veya şifre hatalı, tekrar deneyiniz!'
                });
            } else if (error.response.status === 400) {
                notification.error({
                    message: 'Hata',
                    description: error.response.data
                });
                this.setState({notFound: true});
            } else if (error.response.status === 403) {
                notification.error({
                    message: 'Hata',
                    description: "Bu sayfayı görmeye yetkiniz bulunmamaktadır."
                });
                this.setState({accessError: true});
            } else {
                this.setState({serverError: true});
            }
            this.setState({loadingTable: false});
        });
    }

    onChange(pagination, filters, sorter) {
        this.setState({
            accessor: sorter.field ? sorter.field : this.state.accessor,
            current: pagination.current,
            pageSize: pagination.pageSize
        }, () => this.fetchData());
    }


    showError = (error) => {
        if (error.status === 404) {
            this.setState({notFound: true});
        } else if (error.response.status === 401) {
            notification.error({
                message: 'Hata',
                description: 'Kullanıcı adı veya şifre hatalı, tekrar deneyiniz!'
            });
        } else if (error.response.status === 400) {
            notification.error({
                message: 'Hata',
                description: error.response.data
            });
            this.setState({notFound: true});
        } else if (error.response.status === 403) {
            notification.error({
                message: 'Hata',
                description: "Bu sayfayı görmeye yetkiniz bulunmamaktadır."
            });
            this.setState({accessError: true});
        } else {
            this.setState({serverError: true});
        }
    }

    render() {
        if (!this.props.currentUser || this.state.loading) {
            return <LoadingIndicator/>;
        }

        if (this.state.serverError) {
            return <ServerError/>;
        }

        if (this.state.notFound) {
            return <NotFound/>;
        }

        if (this.state.accessError) {
            return <AccessError/>;
        }

        const columns = [
            {
                title: 'Şube',
                dataIndex: 'sender',
                key: 'sender',
                width: '6%',
                render: (text, record) => (
                    <label>{record.sender}</label>
                )
            },
            {
                title: 'VKN',
                dataIndex: 'kullaniciVergiNo',
                key: 'kullaniciVergiNo',
                width: '10%'
            },
            {
                title: 'TCKN',
                dataIndex: 'kullaniciKimlikNo',
                key: 'kullaniciKimlikNo',
                width: '5%'
            },
            {
                title: 'Barkod',
                dataIndex: 'barcode',
                key: 'barcode',
                width: '5%',
                render: (text, record) => (<div>
                        <Tag color="gray">{record.barcode}</Tag>
                    </div>
                )
            },
            {
                title: 'Unvan',
                dataIndex: 'unvan',
                key: 'unvan',
                width: '15%'
            },
            {
                title: 'Durum',
                dataIndex: 'teslimatDurumu',
                key: 'teslimatDurumu',
                width: '6%',
                render: (text, record) => (<div>
                        <Tag color="green">Ödendi</Tag>
                        <Tag color="blue">Teslim Edilmeli</Tag>
                        <Tag color="pink">{moment(record.updatedAt).format("DD-MM-YYYY HH:mm")}</Tag>
                    </div>
                )
            }
        ];

        const {total, current, pageSize, content} = this.state;

        return (
            <Col className="home-container">
                <Col className="page-content">
                    <Row gutter={24}>
                        <Card>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <Col lg={5} md={4} sm={8} xs={8} style={{paddingLeft: '0px'}}>
                                    <Text type="secondary"
                                          style={{fontSize: "13px", color: "#000000"}}
                                          strong={true}>İstatistik</Text>
                                </Col>
                                <Table dataSource={this.state.statistics}
                                       bordered={true}
                                       size="small"
                                       columns={ [
                                           {
                                               title: 'Şube',
                                               dataIndex: 'app_name',
                                               key: 'app_name',
                                           },
                                           {
                                               title: 'Unvan',
                                               dataIndex: 'title',
                                               key: 'title',
                                           },
                                           {
                                               title: 'Stok',
                                               dataIndex: 'stok_kalan',
                                               key: 'stok_kalan',
                                           },
                                           {
                                               title: 'Başvuru',
                                               dataIndex: 'basvuru_adet',
                                               key: 'basvuru_adet',
                                           },
                                           {
                                               title: 'Ödenen',
                                               dataIndex: 'odenen',
                                               key: 'odenen',
                                           },
                                           {
                                               title: 'Teslim',
                                               dataIndex: 'teslim_edilen',
                                               key: 'teslim_edilen',
                                           },
                                           {
                                               title: 'Bekleyen',
                                               dataIndex: 'teslim_bekleyen',
                                               key: 'teslim_bekleyen',
                                               render: (text, record) => (
                                                   <Tag color={record.teslim_bekleyen>0 ? "red" :"success"}>{record.teslim_bekleyen}</Tag>
                                               )
                                           }
                                       ]
                                       }
                                       pagination={{
                                           total: this.state.statistics.length,
                                           current:1,
                                           pageSize: 20,
                                           showSizeChanger:false,
                                           showQuickJumper:false,
                                           showTotal:(total) => `Toplam ${total} kayıt`
                                       }}
                                />
                            </Col>

                            <Col lg={24} md={24} sm={24} xs={24} style={{marginTop: '10px'}}>
                                <Col lg={5} md={4} sm={8} xs={8} style={{paddingLeft: '0px'}}>
                                    <Text type="secondary"
                                          style={{fontSize: "13px", color: "#000000"}}
                                          strong={true}>Teslim Bekleyen</Text>
                                </Col>
                                <Table dataSource={content}
                                       rowKey={record => record.recordId}
                                       size="small"
                                       bordered={true}
                                       columns={columns}
                                       loading={this.state.loadingTable}
                                       onChange={this.onChange}
                                       pagination={{
                                           total,
                                           current,
                                           pageSize,
                                           showTotal: (total) => `Toplam ${total} kayıt`
                                       }}
                                />
                            </Col>
                        </Card>
                    </Row>
                </Col>
            </Col>
        );
    }
}

export default FinancialSealHome;


// WEBPACK FOOTER //
// ./src/page/token/home/FinancialSealHome.js